import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { useLocation } from "react-router-dom";
import "./auth_layout.css";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";

interface AuthLayoutProps {
  children: React.ReactNode;
}

const lightTheme = createTheme({
  palette: {
    mode: "light",
    background: {
      default: "#ffffff",
      paper: "#ffffff",
    },
    text: {
      primary: "#1E2036",
      secondary: "#696595",
    },
  },
});

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const location = useLocation();
  const themeContext = useContext(ThemeContext);
  const darkMode = themeContext?.darkMode;

  const getHeaderContent = () => {
    switch (location.pathname) {
      case "/login":
        return {
          title: "Kindle your Defences with SPARK",
          subtitle: "Prevent, Identify and Fortify Vulnerability Gaps",
        };
      case "/login/register":
        return {
          title: "Kindle your CyberDefenses with SPARK",
          subtitle: "Prevent, Identify and Fortify Vulnerability Gaps",
        };
      case "/login/forgot-password":
        return { title: "Precision Insights in Motion" };
      default:
        return {
          title: "Kindle your Defences with SPARK",
          subtitle: "Prevent, Identify and Fortify Vulnerability Gaps",
        };
    }
  };

  const { title, subtitle } = getHeaderContent();

  return (
    <Grid container sx={{ height: "100vh" }} className="img-bg">
      <Grid
        size={{ xs: 12, md: 8.4 }}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "start",
          textAlign: "center",
          color: "white",
          // padding: "20px",
        }}
      >
        <div style={{marginBottom:"60px"}}>
        <Typography variant="h4" fontWeight="bold" sx={{ mt: 20,color: "white",ml: 12 }}>
          "{title}"
        </Typography>
        {subtitle && (
          <Typography variant="h6" sx={{color: "white" }}>
            {subtitle}
          </Typography>
         
        )}
         </div>
      </Grid>

      <Grid
        size={{ xs: 12, md: 3.6 }}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "20px 0px",
          bgcolor: darkMode ? "background.paper" : "white",
        }}
      >
        {children}
      </Grid>
    </Grid>
  );
};

export default AuthLayout;